const getReturnLink = (carrier, country) => {
  const links = returnLinks[carrier];
  if (typeof links === "string") {
    return links;
  }
  return links[country.toLowerCase()] || links.default;
};

const getReturnLinkByCountry = (country) => {
  return returnLinksByCountry[country.toLowerCase()] || "";
};

const returnLinks = {
  bpost: "https://www.bpost.be/fr/points-de-vente",
  chronopost: "https://www.chronopost.fr/expeditionAvanceeSec/ounoustrouver.html",
  colis_prive: "/carriers/relay_points/colis_prive",
  colissimo: "/carriers/relay_points/colissimo",
  deutschepost: "https://www.deutschepost.de/de/s/standorte.html",
  dpd: {
    default: "https://www.dpd.com/",
    at: "https://www.mydpd.at/shopfinder",
    cz: "https://pickup.dpd.cz/?return_allowed=1",
    ie: "https://www.dpd.ie/dpd-pick-up-my-parcel/",
    pl: "https://www.dpd.com/pl/pl/dpd-pickup/znajdz-punkt-dpd-pickup/",
    pt: "https://www.dpdgroup.com/pt/mydpd/parcel-shops?lang=pt",
    si: "https://www.dpdgroup.com/si/mydpd/parcel-shops",
    sk: "https://www.dpdgroup.com/sk/mydpd/parcel-shops",
  },
  mondial_relay: "/carriers/relay_points/mondial_relay",
  post_lu: "https://www.post.lu/particuliers/colis-courrier/trouver-un-point-de-vente",
  post_nl: "https://www.postnl.nl/locatie-wijzer",
  postnord: {
    default: "https://www.postnord.com/services/postnord-return-drop-off/",
    se: "https://www.postnord.se/vara-verktyg/sok-brevlada-eller-servicestalle",
    dk: "https://www.postnord.dk/varktojer/find-os",
  },
};

const returnLinksByCountry = {
  at: "https://www.mydpd.at/shopfinder",
  be: "https://www.bpost.be/fr/points-de-vente",
  cz: "https://pickup.dpd.cz/?return_allowed=1",
  de: "https://www.deutschepost.de/de/s/standorte.html",
  dk: "https://www.postnord.dk/varktojer/find-os",
  ie: "https://www.dpd.ie/dpd-pick-up-my-parcel/",
  lu: "https://www.post.lu/particuliers/colis-courrier/trouver-un-point-de-vente",
  nl: "https://www.postnl.nl/locatie-wijzer",
  pl: "https://www.dpd.com/pl/pl/dpd-pickup/znajdz-punkt-dpd-pickup/",
  pt: "https://www.dpdgroup.com/pt/mydpd/parcel-shops?lang=pt",
  se: "https://www.postnord.se/vara-verktyg/sok-brevlada-eller-servicestalle",
  si: "https://www.dpdgroup.com/si/mydpd/parcel-shops",
  sk: "https://www.dpdgroup.com/sk/mydpd/parcel-shops",
};

export { getReturnLink, getReturnLinkByCountry };
